
import { Component, Prop, Vue } from 'vue-property-decorator';
// import TimeRules from '@/views/record/billing-rules/components/time-rules/index.vue';
// import { eBillingType } from '@/interface/eCommons';
// import { createRule, editRule, getRuleInfo } from '@/api/rules';
// import { iRuleInfo } from '@/interface/rules';
import { iBackupTactics, eType, eDays, eRulesDialogContentStatus } from '@/interface/backup-tactics';
import TimeRules from './_TimeRules.vue';
import { createBackupConfig, getBackupDetail, getBackupSelectList, updateBackupBatchBind, updateBackupConfig } from '@/api/backup-tactics';
import { toast } from '@/utils/common';
@Component({
  components: { TimeRules },
})
export default class EditBackupTactics extends Vue {
  @Prop({ default: false }) dialogVisible!: boolean;
  @Prop() info?: any;
  @Prop() id?: any;
  @Prop() status!: string;
  @Prop({ default: false }) isShowUpdataTacitcs!: boolean;
  @Prop({ default: 0 }) detailId!: number;
  @Prop() idsStr!: string;
  @Prop({ default: [] }) selectList!: any;
  @Prop() area_ids!: any;
  private defaultValue: object = { min: 0, max: 0 };
  private ruleInfo: any = null;
  private submitLoading = false;
  private policy_id: number = 0;
  form: any = { name: '', type: 1 };
  type = 'TimeRules';
  ruleComponent = 'TimeRules';

  private configStatus = eRulesDialogContentStatus;
  public get title(): string {
    if (this.status === eRulesDialogContentStatus.EDIT) {
      return '修改策略';
    } else if (this.status === eRulesDialogContentStatus.CREATE) {
      return '新建策略';
    } else {
      return '策略详情';
    }
  }
  handleClose() {
    this.$emit('update:dialogVisible', false);
  }
  /**
   * 校验填入价格 只能是数字
   */
  changePrice(e: string, key: string, type: string) {
    if (!e) {
      this.ruleInfo.common.backup_num[key][type] = e;
    } else {
      const reg = RegExp(/^\d*$/);
      if (reg.test(e)) {
        this.ruleInfo.common.backup_num[key][type] = Number(e);
      }

      this.$set(this.ruleInfo.common.backup_num[key], type, Number(e));
    }
  }
  // async createNewRule() {}
  async submit() {
    try {
      this.submitLoading = true;
      /* 节点列表更改策略 */
      if (this.isShowUpdataTacitcs) {
        if (this.policy_id == 0) {
          this.$message.error('请选择策略名称！');
          return;
        }
        const bind_policy_type = this.selectList.find((item: any) => {
          // console.log(item, this.policy_id);

          return item.id == this.policy_id;
        }).type;

        const data = { area_ids: this.area_ids, bind_policy_id: this.policy_id, bind_policy_type };
        this.$msgbox({
          title: '是否确认，修改节点备机策略？',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = '执行中...';
              // 发送修改请求
              try {
                const { msg, code } = await updateBackupBatchBind(data);
                if (code == 0) {
                  this.$emit('succss', true);
                } else {
                  toast(msg, 'error');
                }
              } catch (err) {
                console.log(err);
              } finally {
                done();
                instance.confirmButtonLoading = false;
              }
            } else {
              done();
            }
          },
        });
      } else {
        /* 新增，修改策略 */
        const params = JSON.parse(JSON.stringify(this.ruleInfo));
        if (!this.ruleInfo.checked) {
          params.custom = [];
        }

        if (this.status === eRulesDialogContentStatus.CREATE) {
          const { msg, code } = await createBackupConfig(params);
          if (code == 0) {
            this.$emit('succss', true);
          } else {
            toast(msg, 'error');
          }
        } else if (this.status === eRulesDialogContentStatus.EDIT) {
          const { msg, code } = await updateBackupConfig(params);
          if (code == 0) {
            this.$emit('succss', true);
          } else {
            toast(msg, 'error');
          }
        }
      }
    } catch (error) {
      console.log('error:', error);
    } finally {
      this.submitLoading = false;
    }
  }

  async getBackupDetail() {
    this.ruleInfo = null;
    if (this.policy_id > 0) {
      try {
        const res = await getBackupDetail(this.policy_id);

        if (res.code == 0) {
          this.ruleInfo = res.data;
          this.setNoLux(this.ruleInfo);
        }
      } catch (err) {
        console.log(err);
      }
    } else {
      this.clearRuleInfo();
    }
  }
  setNoLux(ruleInfo: any) {
    const { common, custom } = ruleInfo;

    /* 2022 新增尊享 */
    if (this.ruleInfo) {
      {
        if (!common.backup_num.lux) {
          this.ruleInfo.common.backup_num.lux = this.defaultValue;
        }
        if (custom) {
          custom.forEach((item: any) => {
            if (!item.backup_num.lux) {
              item.backup_num.lux = this.defaultValue;
            }
          });
        }
      }
    }
  }
  mounted() {
    if (this.detailId > 0) {
      this.policy_id = this.detailId;
      this.getBackupDetail();
    } else if (this.info) {
      this.ruleInfo = this.info;
      this.setNoLux(this.ruleInfo);
    } else {
      this.clearRuleInfo();
    }
  }
  clearRuleInfo() {
    this.ruleInfo = {
      name: '',
      type: eType.CUSTOM,
      common: {
        backup_num: {
          low: { min: 0, max: 0 },
          high: { min: 0, max: 0 },
          free: { min: 0, max: 0 },
          lux: { min: 0, max: 0 },
        },
      },
      custom: [
        {
          backup_days: [],
          backup_periods: [
            {
              start: 0,
              end: 0,
            },
          ],
          backup_num: {
            low: { min: 0, max: 0 },
            high: { min: 0, max: 0 },
            free: { min: 0, max: 0 },
            lux: { min: 0, max: 0 },
          },
        },
      ],
    };
  }
}
